import React from "react";

function SkeletonLoader() {
  return (
    <div class="flex flex-col gap-1 border-[#dedbdb] pb-2 animate-pulse">
      <div class="mt-4 flex justify-start items-center flex-row space-x-10">
        <div class="flex rounded-full w-14 h-14  bg-[#dedbdb]"></div>
        <div class="flex flex-col justify-start w-2/3">
          <div class="h-3 bg-[#dedbdb]"></div>
          <div class="h-3 bg-[#dedbdb] mt-1"></div>
          <div class="h-2 bg-[#dedbdb] mt-1"></div>
        </div>
      </div>
      <div class="images flex flex-wrap gap-1">
        <div class="h-14 w-14 sm:w-20 sm:h-20 bg-[#dedbdb]"></div>
        <div class="h-14 w-14 sm:w-20 sm:h-20 bg-[#dedbdb] ml-2"></div>
      </div>
      <div class="h-4 bg-[#dedbdb] mt-2"></div>
    </div>
  );
}

export default SkeletonLoader;
